import {
    CHANGE_BRAND,
    PLASTIC_REDEMPTION,
    UNBRANDED_TO_EGIFT,
    UNBRANDED_TO_LINK,
} from '@/src/modules/pg-plus/constants'
import ChangeBrandInWalletOrGiftDetails from '@/src/modules/account/received/redemption-methods/ChangeBrandInWalletOrGiftDetails'
import PlasticRedemptionInWalletOrGiftDetails from '@/src/modules/account/received/redemption-methods/PlasticRedemptionInWalletOrGiftDetails'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'
import { BrandSearchContextProvider } from '@/src/modules/algolia/BrandSearchContext'
import { useReceivedGiftsContext } from '@/src/common/contexts/ReceivedGiftsContext'

const ChangeRedemptionAdditionalStep = () => {
    const { giftState } = usePGPlusStepAndModalContext()
    const { redemptionSelection } = giftState
    const { refetchGift } = useReceivedGiftsContext()

    if (
        [CHANGE_BRAND, UNBRANDED_TO_LINK, UNBRANDED_TO_EGIFT].includes(
            redemptionSelection
        )
    ) {
        return (
            <BrandSearchContextProvider
                flow={'pg_plus_redemption'}
                existingGiftSlug={giftState?.brandSlug}
            >
                <ChangeBrandInWalletOrGiftDetails
                    hasBeenCardLinked={true}
                    brandImage={''}
                    refetchGift={refetchGift}
                />
            </BrandSearchContextProvider>
        )
    }

    if (redemptionSelection === PLASTIC_REDEMPTION) {
        return (
            <PlasticRedemptionInWalletOrGiftDetails
                hasBeenCardLinked={true}
                showBackButton={false}
                refetchGift={refetchGift}
            />
        )
    }

    return <></>
}

export default ChangeRedemptionAdditionalStep
